import customSelect from 'custom-select';

/**
 * Render the custom select for the archive filter.
 */
customSelect('#archiveSearch');
customSelect('#archiveSearchTopic');

if ( $('.nominees-dashboard__filters .custom-select, .map-box .custom-select').length ) {
	$('.custom-select-opener').append('<i class="wec-icon-arrow-harsh-down"></i>');
}
